import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import ConductOutreachPageContent from "app/components/outreach/ConductOutreachPageContent";

const ConductOutreachPage = (props) => {
  const { t } = useTranslation();

  return (
    <Page
      hasDrawer={false}
      pageTitle={t("pageTitle.conductOutreach")}
      hasBackButton={true}
      backButtonTooltip={t("common.backButtonToolTip")}
      contentComponent={ConductOutreachPageContent}
      {...props}
    />
  );
};

export default ConductOutreachPage;
